export const documents = {
  agreement: "oyado/agreement",
  privacy_policy: "oyado/privacy_policy",
  host_service_agreement: "oyado/host_service_agreement_20250430"
}
